// removed by extract-text-webpack-plugin
module.exports = {"thumbBar":"thumbBar__1caRt","open":"open__xNZc8","buttonwrapper":"buttonwrapper__1Igbm","button":"button__2OrBZ","icon":"icon__LDGBw","trigger":"trigger__2Q3GZ","label":"label__X-txc","content":"content__2_wlg","imgwrapper":"imgwrapper__3LuF9","thumb":"thumb__cFLSm","active":"active__2Pcbv","desc":"desc__2iOoQ"};


//////////////////
// WEBPACK FOOTER
// ./components/thumbbar/scss/thumbbar.scss
// module id = OwJ7
// module chunks = 0